(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-grades"]) return;
  try {
    
  if (!customElements.get('m-grades')) {
  customElements.define(
    'm-grades',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const gradingButtons = this.querySelectorAll('.grade-page-button');
        const gradingContents = this.querySelectorAll('.grading-content');
        gradingButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
              gradingButtons.forEach(i => i.classList.remove('active'));
              button.classList.add('active');
              gradingContents.forEach(i => i.classList.remove('active'));
              this.querySelector('.grading-content[data-grade-tab="' + button.getAttribute('data-tab') + '"]').classList.add('active');
            });
        });
      }
    }
    )
  }

  } catch(e) { console.error(e); }
})();
})();
